import * as ReactDOM from 'react-dom';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { dragTipTemplate } from '../../Templates';

// Drag info tip rendering
let infoTipContainer: HTMLDivElement;

export default function ensureDragTipMounted(store: CalendarSurfaceStore) {
    if (!infoTipContainer) {
        infoTipContainer = document.createElement('div');
        document.body.appendChild(infoTipContainer);
        ReactDOM.render(dragTipTemplate(store), infoTipContainer);
    }
}
